<div [class.menu-fixo]="isFichaDaObraActive">
  <div class="header">
    <div class="header-top">

      <div class="header-logo">
        <a routerLink="/" class="logo-link">
          <img
            src="{{ BASE_IMG_URL }}assets/logo/rdo-logo.png"
            alt="Rede de Obras"
            class="logo-img"
          />
        </a>
      </div>

      <div class="header-search">
        <div class="search-container">
          <select
            [(ngModel)]="searchOption"
            class="search-select"
            [disabled]="bloquearMenu || level === 'Restrito'"
          >
            <option value="empresa">busca por empresa</option>
            <option value="id">busca por id/obra</option>
          </select>
          <div class="input-wrapper">
            <input
              type="text"
              class="search-input"
              [(ngModel)]="searchQuery"
              (keyup.enter)="onSearchEnter()"
              [placeholder]="searchOption === 'empresa' ? 'Buscar pelo nome da empresa' : 'Buscar por ID ou nome da obra'"
              maxlength="45"
              [disabled]="bloquearMenu || level === 'Restrito'"
            />
          </div>
        </div>
      </div>

      <div class="header-user">
        <div class="user-info">
          <span class="user-greeting">Olá, {{ userName }}</span>
          <span class="user-level">{{ level }}</span>
        </div>

        <button
          class="avatar-btn"
          routerLink="/usuario"
          [disabled]="bloquearMenu"
          title="Meu perfil"
          type="button"
        >
          <span class="avatar-initials">{{ userInitials }}</span>
        </button>

        <a
          href="https://e-construmarket.movidesk.com/kb/article/211758/rede-de-obras-base-de-conhecimentos"
          class="action-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <mat-icon aria-hidden="true">help_outline</mat-icon>
          <span>Ajuda</span>
        </a>

        <button class="action-link"  type="button" (click)="sair()">
          <mat-icon aria-hidden="true">logout</mat-icon>
          <span>Sair</span>
        </button>
      </div>

    </div>

    <nav class="navbar">
      <ul class="nav-list">

        <li class="nav-item">
          <a class="nav-link" routerLink="/">
            Home
          </a>
        </li>

              <li
          class="nav-item nav-item--dropdown"
          #buscasMenu
          (mouseenter)="onBuscasMouseEnter()"
          (mouseleave)="onBuscasMouseLeave()"
          [class.disabled]="bloquearMenu"
          *ngIf="level !== 'Restrito'"
        >
          <button
            class="nav-link nav-link--btn"
            [disabled]="bloquearMenu"
            [class.active]="buscasDropdownVisible"
            type="button"
          >
            Buscas por obras
            <mat-icon class="nav-chevron" aria-hidden="true">
              {{ buscasDropdownVisible ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </button>

          <div
            class="dropdown-panel"
            *ngIf="buscasDropdownVisible"
            (mouseenter)="onDropdownMouseEnter()"
            (mouseleave)="onDropdownMouseLeave()"
          >
            <app-bloco-buscas
              (closeBuscas)="closeBuscas()"
              [menuModules]="menuModules"
            ></app-bloco-buscas>
          </div>
        </li>

        <li
          class="nav-item nav-item--dropdown"
          #empresasMenu
          (mouseenter)="onEmpresasMouseEnter()"
          (mouseleave)="onEmpresasMouseLeave()"
          [class.disabled]="bloquearMenu"
          *ngIf="level !== 'Restrito' && exibirAbaEmpresas"
        >
          <button
            class="nav-link nav-link--btn"
            [disabled]="bloquearMenu"
            [class.active]="empresasDropdownVisible"
            type="button"
          >
            Buscas por Empresas
            <mat-icon class="nav-chevron" aria-hidden="true">
              {{ empresasDropdownVisible ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </button>

          <div
            class="dropdown-panel"
            *ngIf="empresasDropdownVisible"
            (mouseenter)="onEmpresasDropdownMouseEnter()"
            (mouseleave)="onEmpresasDropdownMouseLeave()"
          >
            <app-bloco-empresas
              (closeEmpresas)="closeEmpresas()"
            ></app-bloco-empresas>
          </div>
        </li>

  

        <li
          class="nav-item"
          [class.disabled]="bloquearMenu"
          *ngIf="level !== 'Restrito' && exibirAbaEmpresas"
        >
          <a
            class="nav-link"
            routerLink="/empresas/minha-carteira"
            [class.disabled]="bloquearMenu"
          >
            Carteira
          </a>
        </li>

        <li class="nav-item" [class.disabled]="bloquearMenu">
          <a class="nav-link" routerLink="/tarefas" [class.disabled]="bloquearMenu">
            Tarefas
          </a>
        </li>

        <li class="nav-item" [class.disabled]="bloquearMenu">
          <a
            class="nav-link"
            routerLink="/relatorios"
            [class.disabled]="bloquearMenu"
          >
            Relatórios
          </a>
        </li>

     @if (exportWork === true) {
        <li class="nav-item" [class.disabled]="bloquearMenu">
          <button
            class="nav-link nav-link--btn"
            [disabled]="bloquearMenu"
            (click)="toggleAba('abaExportacaoVisivel')"
            [class.active]="abaExportacaoVisivel"
            data-exportacao-toggle
            type="button"
          >
            Exportação
          </button>
        </li>
        
     }
      

        <li class="nav-item" [class.disabled]="bloquearMenu" *ngIf="level !== 'Restrito'">
          <a class="nav-link" routerLink="/estatisticas" [class.disabled]="bloquearMenu">
            Estatísticas
          </a>
        </li>

      </ul>
    </nav>

    @if (buscasDropdownVisible) {
      <div
        class="dropdown-panel"
        (mouseenter)="onDropdownMouseEnter()"
        (mouseleave)="onDropdownMouseLeave()"
      >
        <app-bloco-buscas
          (closeBuscas)="closeBuscas()"
          [menuModules]="menuModules"
        ></app-bloco-buscas>
      </div>
    }

    @if (abaExportacaoVisivel) {
      <app-bloco-exportacao
        (fechaBuscas)="toggleAba('abaExportacaoVisivel')"
      ></app-bloco-exportacao>
    }

  </div>
</div>